import { ROUTER_ADMIN_PASSWORD_UPDATE_STATUS } from '../enums/router-admin-password-update-status.enum';

export enum ROUTER_ADMIN_CREDENTIAL_ACTION {
  GENERATED = 'generated',
  PUSHED = 'pushed',
  SYNCED_FROM_PROVIDER = 'synced_from_provider',
}

export type RouterAdminCredentialsType = {
  username: string | null;
  password: string | null;
  pendingPassword: string | null;
  status: ROUTER_ADMIN_PASSWORD_UPDATE_STATUS | null;
  jobId: string | null;
  message: string | null;
  requestedAt: string | null;
  completedAt: string | null;
};

export type RouterAdminCredentialHistoryItemType = {
  id: number;
  serialNumber: string;
  routerId: number | null;
  username: string | null;
  password: string | null;
  action: ROUTER_ADMIN_CREDENTIAL_ACTION;
  routerType: string | null;
  pushToDevice: boolean;
  status: ROUTER_ADMIN_PASSWORD_UPDATE_STATUS | null;
  jobId: string | null;
  message: string | null;
  requestedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  createdByUserId: number | null;
};

export type RouterAdminCredentialHistoryType = {
  items: RouterAdminCredentialHistoryItemType[];
  meta: {
    totalItems: number;
    totalPages: number;
  };
};
